import React from 'react';
import { Space } from 'antd';
import { useStakeholders } from '@hooks';
import { COPY_SPECIFIC, TAG_COLORS } from '@sonar-software/sonar-ts-constants';
function getDotBackgroundColor(groupId, index) {
    if (groupId === 'detected-combo') {
        return '#FAFAFA';
    }
    return `${TAG_COLORS[index % TAG_COLORS.length]}19`;
}
function getDotBorderColor(groupId, index) {
    if (groupId === 'detected-combo') {
        return '#D9D9D9';
    }
    return TAG_COLORS[index % TAG_COLORS.length];
}
export const GroupLegend = ({ groupIds }) => {
    const stakeholders = useStakeholders();
    return (React.createElement("div", { className: 'groups' },
        React.createElement("div", { className: 'groups-header' }, COPY_SPECIFIC.GROUPS),
        React.createElement(Space, { align: 'start', size: 'small', wrap: true }, groupIds.map((groupId, index) => {
            var _a, _b;
            return React.createElement("div", { className: 'grouping', key: groupId },
                React.createElement("span", { className: 'group-dot', style: {
                        backgroundColor: getDotBackgroundColor(groupId, index),
                        borderColor: getDotBorderColor(groupId, index)
                    } }),
                React.createElement("span", { className: 'group-label' }, (_b = (_a = stakeholders.find((stakeholder) => `${stakeholder.stakeholderId}-combo` === groupId)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : COPY_SPECIFIC.UNREVIEWED));
        }))));
};
